import { useNavigate, useSimulatorMetadata } from 'hooks';
import { generateCampaignSimulatorPreviewPath } from 'modules/campaigns/services/utils';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useSimulatorMonitor } from './hooks/useSimulatorMonitor';

export const useSimulatorButton = ({ campaignId, accountId, monitorId }) => {
    const navigate = useNavigate();
    const { trackSimulatorClick } = useSimulatorMonitor(monitorId);

    const isSimulatorButtonEnabled = useConfigMatch({
        [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_BUTTON_ENABLED]: 'true',
    });

    const hasRequiredProps = !!campaignId && !!accountId;

    const { isSuccess: isSimulatorEligible } = useSimulatorMetadata({
        campaignId,
        accountId,
        enabled: isSimulatorButtonEnabled && hasRequiredProps,
    });

    const shouldRender = hasRequiredProps && isSimulatorButtonEnabled && isSimulatorEligible;

    const handleClick = () => {
        trackSimulatorClick();

        const simulatorPath = generateCampaignSimulatorPreviewPath({
            accountId,
            campaignId,
        });
        navigate(simulatorPath);
    };

    return {
        shouldRender,
        handleClick,
    };
};
